module.exports = __webpack_public_path__ + "Roboto-Light.ea36cd9a0e9eee97012a.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/roboto/Roboto-Light.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Light.woff
// module chunks = styles